import React from 'react';
import { connect, Provider } from 'react-redux';
import { codeBenchActions } from '@codametrix/ui-common';
import { CaseCancellation, CaseCancellationProps } from './case-cancellation';

const { cancelInvoicesConfirm, cancelInvoicesDismiss } = codeBenchActions;

export const mapStateToCaseCancellationProps = (state: any): any => {
  return {
    ...state.codeBench,
    ...state.ampUI,
    cursorAPIContext: { ...state.capabilities.cursorAPIContext }
  };
};

export const mapDispatchToCaseCancellationProps = (dispatch: any) => {
  return {
    onCaseCancelDismiss: (
      ev: React.MouseEvent | React.FormEvent | CustomEvent
    ) => {
      dispatch(cancelInvoicesDismiss());
    },
    onCaseCancel: (submission: AmplifyAPI.Submission) => {
      dispatch(cancelInvoicesConfirm(submission));
    }
  };
};
